<template>
  <div>
    <div ref="searchBox">
      <el-form :inline="true" :model="searchFrom" ref="searchFrom" class="demo-form-inline" label-width="110px" size="mini">
        <div class="inpBox timeBox">
          <el-form-item label="船运单号:" prop="shipTransportNo">
            <el-input placeholder="" v-model="searchFrom.shipTransportNo"></el-input>
          </el-form-item>
          <el-form-item label="航次号:" prop="shipDateNo">
            <el-input placeholder="" v-model="searchFrom.shipDateNo"></el-input>
          </el-form-item>
          <el-form-item label="船舶名称:" prop="shipName">
            <el-input placeholder="" v-model="searchFrom.shipName"></el-input>
          </el-form-item>
          <el-form-item label="船运状态 :" prop="shipStatus">
            <el-select v-model="searchFrom.shipStatus" placeholder="请选择">
              <el-option v-for="val in status" :label="val.name" :value="val.id" :key="val.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间:" prop="createTime">
            <el-date-picker v-model="searchFrom.createTime" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
        </div>
        <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item btnCode="00KP001B001" v-if="btnFlg[0]">
            <el-button type="primary" @click="addFn">新增</el-button>
          </el-form-item>
          <!-- <el-form-item btnCode="00KP001B002" v-if="btnFlg[1]">
            <el-button type="primary" @click="delDeiver">删除</el-button>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="hwStatistics" v-if="btnFlg[14]">货位统计</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="dayin" v-if="btnFlg[13]">打印舱标</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="jiesuandanFn" v-if="btnFlg[15]">生成结算单</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class=" table" :style="{height:h}">
      <el-table :data="tableList" ref="table" highlight-current-row v-loading="loading" bordersize="mini" height="100%" style="width: 100%" center border
       @row-click="handleRowClick">
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column fixed type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="mini" btnCode="00KP001B003" v-if="btnFlg[2]&&scope.row.shipStatus!=1301" @click="shipEditFn(scope.row)">修改</el-button>
              <el-button type="text" size="mini" btnCode="00KP001B004" v-if="btnFlg[3]" @click="rizhiFn(scope.row,1)">日志</el-button>
              <el-button type="text" size="mini" btnCode="00KP001B004" v-if="btnFlg[1]&&scope.row.shipStatus!=1301" @click="delFn(scope.row)">删除</el-button>
              <!-- <el-button type="text" size="mini" btnCode="00KP001B005" v-if="scope.row.shipStatus!=1&&btnFlg[4]" @click="zuobiaoFn(scope.row)">坐标</el-button> -->
              <el-button type="text" size="mini" btnCode="00KP001B00B" v-if="scope.row.businessStatus!=1001&&btnFlg[10]" @click="monitorFn(scope.row)">监控</el-button>
              <el-button type="text" size="mini" btnCode="00KP001B00A" v-if="btnFlg[9]" @click="qingdanFn(scope.row)">码单</el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="shipTransportNo" width="240" :show-overflow-tooltip="true" label="船运单号"></el-table-column>
        <el-table-column prop="belongCompany" width="240" :show-overflow-tooltip="true" label="隶属公司"></el-table-column>
         <el-table-column prop="shipFlowName" width="150" :show-overflow-tooltip="true" label="流向"></el-table-column>
        <el-table-column property="shipStatus" label="船运状态" width="200" :formatter="statusFormat"></el-table-column>
        <el-table-column prop="shipDateNo" width="200" :show-overflow-tooltip="true" label="航次号"></el-table-column>
        <el-table-column prop="shipName" width="160" :formatter="emptyFn" label="船舶名称"></el-table-column>
        <el-table-column prop="dealDuration" width="160" :formatter="emptyFn" label="合约时长(小时)"></el-table-column>
        <!-- <el-table-column prop="factDemurrageDay" width="160" :formatter="emptyFn" label="实际滞期时长(天)"></el-table-column> -->
        <el-table-column prop="productWeight" width="160" :formatter="emptyFn" label="保底重量(吨)"></el-table-column>
        <el-table-column prop="weight" width="160" :formatter="emptyFn" label="实际载货(吨)"></el-table-column>
        <el-table-column prop="number" width="160" :formatter="emptyFn" label="实际件数"></el-table-column>
        <el-table-column prop="deliverAddressName" width="300" :formatter="emptyFn" label="起始码头"></el-table-column>
        <el-table-column prop="receivingAddressName" width="300" :formatter="emptyFn" label="目的码头"></el-table-column>
        <el-table-column prop="createUserName" width="130" :formatter="emptyFn" label="创建人"></el-table-column>
        <el-table-column prop="createTime" width="170" :formatter="dateTimeFormat"  label="创建时间"></el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div style="text-align: right;">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchFrom.pageNo" :page-sizes="[25,50,100]" :page-size="searchFrom.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <!-- 船期新建修改 -->
    <el-dialog :title="title" :close-on-click-modal="false" :close-on-press-escape="false" class="jiaoyan" @close="closeDialog" :visible.sync="dialogVisible" width="400px" center>
      <span>
        <el-form :inline="true" :rules="rules" :model="addFrom" ref="addFrom" class="demo-form-inline" label-width="120px" size="mini">
          <div class="inpBox">
            <!-- <el-form-item label="关联系统编号:" prop="shipName">
              <el-select v-model="addFrom.contractNoO" value-key="id" placeholder="请选择" filterable @change="hetongChange">
                <el-option v-for="(item) in HTList" :label="item.contractSysNo" :value="item" :key="item.id"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="隶属公司:" class="jiage" prop="belongCompany">
                <el-select  v-model="addFrom.belongCompany"    placeholder="请选择">
                  <el-option  label="中物唐山曹妃甸区物流有限责任公司" value="中物唐山曹妃甸区物流有限责任公司" ></el-option>
                  <el-option  label="中物(北京)物流信息服务有限公司唐山曹妃甸分公司" value="中物(北京)物流信息服务有限公司唐山曹妃甸分公司" ></el-option>
                  <el-option  label="金刚鲸(天津)供应链管理有限公司" value="金刚鲸(天津)供应链管理有限公司" ></el-option>
                  <el-option  label="第三方公司" value="第三方公司" ></el-option>
                </el-select>
              </el-form-item>
            <el-form-item label="船舶名称:" prop="shipNameO">
              <el-select  v-model="addFrom.shipNameO"  value-key="id"  placeholder="请选择" filterable >
                <el-option v-for="(item,index) in CBNameList" :label="item.shipName" :value="item" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="航次号:" prop="shipDateNo">
              <el-input placeholder="" maxlength="10"  v-model="addFrom.shipDateNo"></el-input>
            </el-form-item>
            <el-form-item label="流向:" prop="shipFlow">
                <el-select  v-model="addFrom.shipFlow"  value-key="id"  placeholder="请选择" filterable>
                  <el-option v-for="(item,index) in LXList" :label="item.showName" :value="item" :key="index"></el-option>
                 </el-select>
              </el-form-item>
             <el-form-item label="合约时长:" class="jiage" prop="dealDuration" >
              <el-input  placeholder=""  v-number-input.float="1"  maxlength="8" v-model="addFrom.dealDuration" ></el-input><span class="danwei">小时</span>
            </el-form-item>
            <el-form-item label="保底重量:" class="jiage" prop="productWeight"  >
              <el-input  placeholder=""  v-number-input.float="2"  maxlength="8" v-model="addFrom.productWeight" ></el-input><span class="danwei">吨</span>
            </el-form-item>
             <el-form-item label="运价:" class="jiage" prop="unitPrice"  >
              <el-input  placeholder=""  v-number-input.float="2"  maxlength="8" v-model="addFrom.unitPrice" ></el-input><span class="danwei">元/吨</span>
            </el-form-item>
            <el-form-item label="起始码头:" prop="deliverAddressId" class="jiage">
              <el-select v-model="addFrom.deliverAddressId" placeholder="请选择" filterable @change="qishiChange">
                <el-option v-for="(item) in MTList" :label="item.addressName" :value="item.id" :key="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="jiage" v-for="(domain, index) in addFrom.mudigang" :label="'目的码头' +(index-0+1)" :key="domain.key" :prop="'mudigang.' + index + '.id'" :rules="{required: true, message: '目的码头不能为空', trigger: 'blur' }">
              <el-select v-model="domain.id" value-key="id" placeholder="请选择" filterable @change="mudiChange($event,index)">
                <el-option v-for="(item) in MTList" :label="item.addressName" :value="item.id" :key="item.id"></el-option>
              </el-select>
              <div class="iconBox" v-if="index==0" @click="addMudidi"><i class="el-icon-circle-plus-outline"></i></div>
              <div class="iconBox" v-else @click="delMudidi(index)"><i class="el-icon-delete"></i></div>
            </el-form-item>
             <el-form-item label="备注:" class="remark" prop="remark" >
              <el-input  placeholder="" type="textarea" rows="1"  maxlength="30" v-model="addFrom.remark"></el-input>
            </el-form-item>
          </div>
        </el-form>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveFn('addFrom')">确 定</el-button>
      </span>
    </el-dialog>
    <rizhi :row-data="row" v-if="rizhiFlag" @destroy="destroy"></rizhi>
    <monitorMap :row-data="row" v-if="monitorMapFlag" @destroy="destroy"></monitorMap>
    <dayinDialog v-if="DayinDialog" :DayinDialog.sync="DayinDialog" :OrderNumber="shipTransportNo" :ShipName="shipName" :VoyageNo="shipDateNo" :id="shipDateId"></dayinDialog>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import {
  shipDateList, sAddressList, getShipContractListForBindShipData, getContractAddressList, getShipIdAndNameList, shipDateAdd,
  shipDateUpdate, shipDateDel, sCrmDictionaryList
} from '@/api/shipping'
import { dateTimeFormat, dateFormat, emptyFn } from '@/utils/util'
import rizhi from '@/views/shipping/shipingBill/rizhi.vue'
import monitorMap from '@/views/shipping/shipingBill/monitorMap.vue'
import dayinDialog from './daYinDialog.vue'
export default {
  components: {
    rizhi,
    monitorMap,
    dayinDialog
  },
  data () {
    var id = this.$route.query.id
    return {
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      emptyFn: emptyFn,
      h: 500,
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      total: 0,
      loading: 'false',
      status: [
        { name: '请选择', id: '' },
        { name: '未开始', id: 1001 },
        { name: '已抵锚', id: 1101 },
        { name: '已起锚', id: 1102 },
        { name: '已靠泊', id: 1103 },
        { name: '已离泊', id: 1104 },
        { name: '已封航', id: 1105 },
        { name: '已解封', id: 1106 },
        { name: '装船完成', id: 1201 },
        { name: '卸船完成', id: 1202 },
        { name: '已完成', id: 1301 }
      ],
      rules: {
        shipDateNo: [
          { required: true, message: '请输入航次号', trigger: 'blur' }
        ],
        customerNameO: [
          { required: true, message: '请选择客户名称', trigger: 'blur' }
        ],
        shipNameO: [
          { required: true, message: '请选择船舶名称', trigger: 'blur' }
        ],
        belongCompany: [
          { required: true, message: '请选择运单标识', trigger: 'blur' }
        ],
        deliverAddressId: [
          { required: true, message: '请选择起始码头', trigger: 'blur' }
        ],
        receivingAddressIds: [
          { required: true, message: '请选择目的码头', trigger: 'blur' }
        ],
        // dealDuration: [
        //   { required: true, message: '请输入合约时长', trigger: 'blur' }
        // ],
        // productWeight: [
        //   { required: true, message: '请输入保底重量', trigger: 'blur' }
        // ],
        shipFlow: [
          { required: true, message: '请选择流向', trigger: 'blur' }
        ]
        // unitPrice: [
        //   { required: true, message: '请输入运价', trigger: 'blur' }
        // ]
      },
      addFrom: {
        mudigang: [{ key: 1 }]
      }, // 船期新建修改
      LXList: [],
      dialogVisible: false,
      title: '新建',
      HTList: [],
      MTList: [],
      CBNameList: [], // 船舶列表
      // 日志
      rizhiFlag: false,
      row: {},
      // 监控
      monitorMapFlag: false,
      btnFlg: [],
      btnIdArr: ['00KP001B001', '00KP001B002', '00KP001B003',
        '00KP001B004', '00KP001B005', '00KP001B006', '00KP001B007',
        '00KP001B008', '00KP001B009', '00KP001B00A', '00KP001B00B',
        '00KP001B00C', '00KP001B00D', '00KM000100', '00KM000200', '00KM000300'],
      DayinDialog: false,
      shipDateNo: '', // 打印舱标传参
      shipTransportNo: '', // 打印舱标传参
      shipName: '', // 打印舱标传参
      shipDateId: '', // 打印舱标传参
      selectRow: null
    }
  },
  created () {
    this.tenantCode = localStorage.getItem('tenantCode')
    this.btnFlg = getBtn(this.btnIdArr, '/shipingBill')
    this.getList()
    sCrmDictionaryList({ groupNo: 'ship_flow' }).then(res => {
      this.LXList = res
    })
    getShipContractListForBindShipData().then(res => {
      this.HTList = res
    })
    sAddressList({ addressType: 2 }).then(res => {
      this.MTList = res
    })
    getShipIdAndNameList().then(res => {
      this.CBNameList = res
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 92) + 'px'
  },
  activated () {
    this.getList()
  },
  methods: {
    // 生成结算单
    jiesuandanFn () {
      if (this.selectRow != null) {
        this.$router.push({ name: 'SshipSettlement', query: { id: this.selectRow.id } })
      } else {
        this.$message.error('请选择一条数据')
      }
    },
    // rizhi
    rizhiFn (row) {
      this.row = row
      this.rizhiFlag = true
    },
    // 选择合同
    hetongChange (e) {
      this.$set(this.addFrom, 'contractNo', e.contractSysNo)
      this.$set(this.addFrom, 'contractId', e.id)
      this.$set(this.addFrom, 'shipName', e.shipName)
      this.$set(this.addFrom, 'shipDateNo', e.shipDateNo)
      this.$set(this.addFrom, 'shipId', e.shipId)
      getContractAddressList({ shipContractId: e.id }).then(res => {
        this.$set(this.addFrom, 'deliverAddressId', res.deliverAddressList[0].addressId)
        res.receiveAddressList.forEach((item, index) => {
          this.$set(this.addFrom.mudigang, index, { key: index + 1, id: item.addressId })
        })
      })
    },
    // 起始港改变
    qishiChange (e) {
      let flag = this.addFrom.mudigang.some(item => item.id == e)
      if (flag) {
        this.$alert('起始码头与目的码头不能相同', '系统提示')
        this.$set(this.addFrom, 'deliverAddressId', null)
      }
      console.log(this.addFrom.mudigang)
    },
    // 目的港改变
    mudiChange (e, index) {
      if (e == this.addFrom.deliverAddressId) {
        this.$alert('起始码头与目的码头不能相同', '系统提示')
        this.$set(this.addFrom.mudigang, index, { key: this.addFrom.mudigang.length + 1 })
      }

      let flag = this.addFrom.mudigang.some((item, n) => {
        if (index != n) {
          return item.id == e
        }
      })
      if (flag) {
        this.$alert('该目的码头已存在', '系统提示')
        this.$set(this.addFrom.mudigang, index, { key: this.addFrom.mudigang.length + 1 })
      }
    },
    addMudidi () {
      if (this.addFrom.mudigang.length == 5) {
        this.$alert('最多添加5个目的码头', '系统提示')
        return
      }
      this.addFrom.mudigang.push({ key: this.addFrom.mudigang.length + 1 })
    },
    delMudidi (index) {
      this.addFrom.mudigang.splice(index, 1)
    },
    hwStatistics () {
      if (this.selectRow != null) {
        this.shipName = this.selectRow.shipName
        this.shipDateNo = this.selectRow.shipDateNo
        this.shipDateId = this.selectRow.id

        this.$router.push({
          path: '/goodsStatistics',
          query: {
            shipName: this.selectRow.shipName,
            shipDateNo: this.selectRow.shipDateNo,
            shipDateId: this.selectRow.id
          }
        })
      } else {
        this.$message.error('请选择一条数据')
      }
    },
    dayin () {
      if (this.selectRow != null) {
        this.shipTransportNo = this.selectRow.shipTransportNo
        this.shipName = this.selectRow.shipName
        this.shipDateNo = this.selectRow.shipDateNo
        this.shipDateId = this.selectRow.id
        this.DayinDialog = true
      } else {
        this.$message.error('请选择一条数据')
      }
    },
    // 监控
    monitorFn (row) {
      this.row = row
      this.monitorMapFlag = true
    },
    // 坐标
    zuobiaoFn (row) {
      this.row = row
      this.coordinateFlag = true
    },
    destroy () {
      this.importDialog = false
      this.rizhiFlag = false
      this.monitorMapFlag = false
    },

    // 添加
    addFn () {
      this.title = '新建'
      this.dialogVisible = true
      this.isAdd = true
    },
    // 选择船名
    shipNameChange () {
      this.$set(this.addFrom, 'shipNo', this.addFrom.shipNameO.shipNo)
    },
    // 船舶修改
    shipEditFn (row) {
      this.addFrom = JSON.parse(JSON.stringify(row))
      this.$set(this.addFrom, 'mudigang', [])
      // this.$set(this.addFrom, 'contractNoO', this.addFrom.contractSysNo)
      this.$set(this.addFrom, 'deliverAddressId', Number(this.addFrom.deliverAddressId))
      if (row.shipId) {
        this.$set(this.addFrom, 'shipNameO', { shipName: row.shipName, id: row.shipId })
      }
      if (this.addFrom.receivingAddressId) {
        let arr = this.addFrom.receivingAddressId.split(',')
        arr.forEach((item, index) => {
          this.$set(this.addFrom.mudigang, index, { key: index + 1, id: Number(item) })
        })
      } else {
        this.$set(this.addFrom.mudigang, 0, { key: 1, id: null })
      }
      if (row.shipFlowId) {
        this.$set(this.addFrom, 'shipFlow', { showName: row.shipFlowName, id: row.shipFlowId })
      }
      this.title = '修改'
      this.dialogVisible = true
      this.isAdd = false
    },
    saveFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.addFrom.shipName = this.addFrom.shipNameO.shipName
          // this.addFrom.shipId = this.addFrom.shipNameO.id
          // if (this.addFrom.receivingAddressNameO.provinceCode) {
          //   for (var key in this.addFrom.receivingAddressNameO) {
          //     if (key.indexOf('update') == -1 && key.indexOf('create') == -1) {
          //       if (key == 'id') {
          //         this.addFrom.receivingAddressId = this.addFrom.receivingAddressNameO[key]
          //       } else {
          //         let name = 'receiving' + key.substring(0, 1).toUpperCase() + key.substring(1)
          //         this.addFrom[name] = this.addFrom.receivingAddressNameO[key]
          //       }
          //     }
          //   }
          // }
          // if (this.addFrom.deliverAddressNameO.provinceCode) {
          //   for (var key in this.addFrom.deliverAddressNameO) {
          //     if (key.indexOf('update') == -1 && key.indexOf('create') == -1) {
          //       if (key == 'id') {
          //         this.addFrom.deliverAddressIds = this.addFrom.deliverAddressNameO[key]
          //       } else {
          //         let name = 'deliver' + key.substring(0, 1).toUpperCase() + key.substring(1)
          //         this.addFrom[name] = this.addFrom.deliverAddressNameO[key]
          //       }
          //     }
          //   }
          // }
          if (this.addFrom.shipNameO) {
            this.$set(this.addFrom, 'shipName', this.addFrom.shipNameO.shipName)
            this.$set(this.addFrom, 'shipId', this.addFrom.shipNameO.id)
          }
          if (this.addFrom.shipFlow) {
            this.addFrom.shipFlowId = this.addFrom.shipFlow.id
            this.addFrom.shipFlowName = this.addFrom.shipFlow.showName
          }
          this.addFrom.receivingAddressIds = []
          this.addFrom.deliverAddressIds = [this.addFrom.deliverAddressId]
          this.addFrom.mudigang.forEach(item => {
            this.addFrom.receivingAddressIds.push(item.id)
          })
          if (this.isAdd) {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            shipDateAdd(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          } else {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            shipDateUpdate(this.addFrom).then(res => {
              loading.close()
              this.$message({
                message: '修改成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.getList(this.searchFrom)
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                duration: 0,
                onClose () {
                  loading.close()
                }
              })
            })
          }
        } else {
          return false
        }
      })
    },
    // 删除
    delFn (row) {
      this.$confirm('是否执行删除操作?', '系统提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        shipDateDel({ id: row.id }).then(res => {
          loading.close()
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 码单
    qingdanFn (row) {
      this.$router.push({ name: 'SbillGoodList', query: { id: row.id, status: row.shipStatus } })
    },
    // 查选
    searchFn () {
      this.getList()
    },
    // 获取列表
    getList () {
      this.loading = true
      shipDateList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    // 状态格式化
    statusFormat (row, column, cellValue) {
      let str = row.ext1 ? '(' + row.ext1 + ')' : ''
      switch (cellValue) {
        case 1001:
          return '未开始' + str
        case 1101:
          return '已抵锚' + str
        case 1102:
          return '已起锚' + str
        case 1103:
          return '已靠泊' + str
        case 1104:
          return '已离泊' + str
        case 1105:
          return '已封航' + str
        case 1106:
          return '已解封' + str
        case 1201:
          return '装船完成' + str
        case 1202:
          return '卸船完成' + str
        case 1301:
          return '已完成' + str
      }
    },
    closeDialog () {
      this.addFrom = { mudigang: [{ key: 1 }] }
      if (this.$refs.addFrom) { this.$refs.addFrom.clearValidate() }
    },
    handleRowClick (row, column, event) {
      this.selectRow = row
      // this.$refs.table.toggleRowSelection(row)
    },
    // 重置
    resetForm (formName) {
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
    }
  },
  inject: ['reload'],
  beforeRouteEnter (to, from, next) {
    to.meta.keepAlive = true
    if (from.path !== '/shipingBill/goodList' && from.path !== '/shipingBill/vehicle' && from.path !== '/shipingBill/inStorage') {
      next(vm => {
        vm.reload()
      })
    } else {
      next()
    }
  },
  beforeRouteLeave (to, from, next) {
    if (to.path == '/shipingBill/goodList' || to.path == '/shipingBill/vehicle' || to.path == '/shipingBill/inStorage') {
      from.meta.keepAlive = true
    } else {
      from.meta.keepAlive = false
    }
    this.importDialog = false
    this.rizhiFlag = false
    this.monitorMapFlag = false
    next()
  }
}
</script>

<style scoped lang='less'>
.searchBtnBox {
  margin-left: 10px;
}
.timeBox /deep/.el-date-editor {
  width: 350px !important;
}
.detailsTitle {
  justify-content: flex-start;
}
/deep/.inpBox .el-input__inner {
  width: 180px;
}
/deep/.inpBox .el-textarea {
  width: 180px;
}
.margin0 {
  margin-left: 10px !important;
}
.iconBox {
  position: absolute;
  right: -28px;
  top: 0;
  font-size: 20px;
  color: #0b25d6;
}
</style>
